import React from 'react';
import { BORDER_TOP, BrandOverline } from '@yme/atoms/brand-overline';
import { Container } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { OverlapContainerStyled } from './styled';
export function OverlapContainer(props) {
    const { id = undefined, children, borderSize = '4px', brandedColor, hasVerticalWhiteGradient = false, bottomIndent, isDefaultVerticalPadding, isRightToLeft = false, } = props;
    const { isMobileView } = useWindowSize();
    const dataTestId = 'OverlapContainer-wrapper';
    return (React.createElement(Container, { id: id, "data-testid": dataTestId, isRightToLeft: isRightToLeft },
        React.createElement(OverlapContainerStyled, { hasVerticalWhiteGradient: hasVerticalWhiteGradient, bottomIndent: bottomIndent },
            React.createElement(BrandOverline, { position: BORDER_TOP, borderColor: brandedColor, borderSize: borderSize, isBorderWidthReset: isMobileView, isDefaultVerticalPadding: isDefaultVerticalPadding }, children))));
}
OverlapContainer.displayName = 'OverlapContainer_AEMComponent';
